import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    body {
        margin: 0;
        padding: 0;
        background: #0a0e27;
        box-sizing: border-box;
        font-family: 'Nunito', Helvetica, Sans-Serif !important;
    }
    
    #content-wrapper {
        background: #0a0e27 !important;
    }
    
    #content {
        background: #0a0e27 !important;
    }
    
    .container-fluid {
        background: #0a0e27 !important;
        min-height: calc(100vh - 70px);
        padding: 24px !important;
    }
    
    /* Melhorias visuais gerais */
    .row {
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
    
    /* Ajustes para textos na área escura */
    .text-muted {
        color: #b0b0b0 !important;
    }
    
    /* Links */
    a {
        color: #00d4ff;
        transition: color 0.3s ease;
        
        &:hover {
            color: #00b8e6;
            text-decoration: none;
        }
    }

    .align-vertical {
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
    }

    .kep-login-facebook {
        text-transform: capitalize !important;
        background-color: transparent !important;
        border: none !important;
        padding: 0px !important;
        color: blue !important;
        font-size: 0.875rem !important;
    }

    .dropdown-item {
        cursor: pointer;
    }

    .btn-group-xs > .btn, .btn-xs {
        padding: 1px 5px !important;
        font-size: 12px !important;
        line-height: 1.5 !important;
        border-radius: 3px !important;
    }

    .swal-text {
        text-align: center;
    }

    .fa-1x {
        font-size: 20px;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    input:-webkit-autofill {
        background-color: white !important; /* Cor personalizada para o fundo */
        transition: background-color 5000s ease-in-out 0s; /* Para garantir que a cor não seja sobrescrita */
        color: rgba(0, 0, 0) !important; /* Cor da fonte */
        -webkit-text-fill-color: rgba(0, 0, 0) !important; /* Para garantir que o texto seja branco */
    }

    .card-balance {
        border: 3px solid rgba(0, 0, 0, 0.07);
        border-radius: 20px;
    }

    .text-black {
        color: #000 !important;
    }

    .img-perfil {
        border-radius: 5px;
        display: inline-block;
        font-size: 30px;
        color: rgb(34, 34, 34);
        width: 90%;
    }

    .img-perfil-modal {
        width: 50%;
    }
    
    .img-camisas-modal {
        width: 90%;
    }
    
    .card {
        border-radius: 1rem!important;
    }

    .card-header {
        border-top-left-radius: 1rem!important;
        border-top-right-radius: 1rem!important;
    }

    .fs-1rem {
        font-size: 1rem!important;
    }
    
    .fs-2rem {
        font-size: 2rem!important;
    }

    .fs-1-5rem {
        font-size: 1.5rem!important;
    }

    .fs-1-25 {
        font-size: 1.25rem!important;
    }

    .font-weight-500 {
        font-weight: 500!important;
    }

    .card-default {
        border-radius: 1rem;
        box-shadow: 0 2px 10px rgba(0,0,0,0.05);
        background-color: #fff;
        position: relative;
    }
    
    .text-yellow {
        color: #f29205!important;
    }
    
    /* Melhorias no Sidebar */
    .sidebar {
        transition: width 0.3s ease !important;
        
        &.toggled {
            width: 6.5rem !important;
        }
        
        &:not(.toggled) {
            width: 14rem !important;
        }
    }
    
    /* Ajustes nos itens de navegação */
    .sidebar .nav-item {
        .nav-link {
            transition: all 0.3s ease !important;
        }
    }
    
    /* Sidebar em mobile - overlay */
    @media (max-width: 767px) {
        .sidebar {
            position: fixed !important;
            left: 0;
            top: 0;
            height: 100vh;
            z-index: 1000;
            width: 14rem !important;
            transform: translateX(-100%);
            transition: transform 0.3s ease !important;
            
            &.toggled {
                transform: translateX(-100%);
                width: 0 !important;
                overflow: hidden;
            }
            
            &:not(.toggled) {
                transform: translateX(0);
                width: 14rem !important;
            }
        }
        
        /* Backdrop quando sidebar está aberto (não toggled) */
        body:not(.sidebar-toggled) .sidebar:not(.toggled)::after {
            content: '';
            position: fixed;
            top: 0;
            left: 14rem;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            z-index: 999;
            pointer-events: none;
        }
        
        /* Content wrapper sempre ocupa 100% em mobile */
        #content-wrapper {
            margin-left: 0 !important;
            width: 100% !important;
        }
    }
    
    /* Esconder sidebar na página de vendas */
    #wrapper.no-sidebar .sidebar {
        display: none !important;
    }
    
    #wrapper.no-sidebar #content-wrapper {
        margin-left: 0 !important;
        width: 100% !important;
    }

    .swal-content:last-child {
        margin-bottom: 0px !important;
        margin-top: 0px !important;
    }
        
    .swal-content {
        padding: 0px !important;
    }

    .swal-modal {
        background: transparent !important;
    }

    .swal-overlay {
        background-color: rgba(0,0,0,.8)!important;
    }
    
`;

export default GlobalStyle;
